module.exports = __webpack_public_path__ + "fonts/Gilroy-Light.721a505d.woff2";